export default __webpack_public_path__ + "static/media/col.9b8f63cc.svg";